import {status, statusNL} from './analysis-status' ;
import {secondsToTimeString,secondsToLongTimeString,dateToString} from '../../../../../Core/Util/time';
import _ from 'lodash';
import {
    currentCulture
} from '../../../../../Core/Util/culture';



const getStatus = (statusInt) => {
    const culture = currentCulture().name;

    return culture === 'nl' ?  
        (_.invert(statusNL))[statusInt] : 
        (_.invert(status))[statusInt] ;
};

export {
    secondsToTimeString,
    secondsToLongTimeString,
    dateToString,
    getStatus
};